import { useContext } from 'react'

import { PipelineBrowserContext } from '../context/context'

export const usePipelineBrowserCommandProvider = () =>
  useContext(PipelineBrowserContext)
